import { Button } from 'bold-ui'
import { useSession } from 'components/auth/useSession'
import { useHistory } from 'react-router'
import Permissions from 'types/Permissions'

interface VisualizarAcompanhamentoButtonProps {
  path: string
  basePath?: string
}

export function VisualizarAcompanhamentoButton(props: Readonly<VisualizarAcompanhamentoButtonProps>) {
  const { path, basePath } = props
  const { hasAuthorization } = useSession({ fetchPolicy: 'cache-only' })
  const history = useHistory()

  if (!hasAuthorization(Permissions.visualizarProntuario)) {
    return null
  }

  const acompanhamentoPath = basePath ? `${basePath}/${path}` : path

  return (
    <Button
      kind='primary'
      size='small'
      skin='outline'
      block
      data-testid='VisualizarAcompanhamentoButton'
      onClick={() => history.push(acompanhamentoPath)}
    >
      Ver acompanhamento
    </Button>
  )
}
